import moment from "moment";

interface ISelection {
	label: string;
}

function getRealNumberFromSelection(obj: ISelection): number | null {
	const numberRegex = /^([+-]?\d+(?:\.\d+)?)/;

	const match = RegExp(numberRegex).exec(obj.label);

	if (!match?.[1]) {
		return null;
	}

	const numberStr = match[1];
	const number = parseFloat(numberStr);

	if (isNaN(number)) {
		return null;
	}
	return number;
}

const isYear = (value: number | null): boolean => {
	const START_YEAR = 1900;
	if (typeof value !== "number") {
		return false;
	}
	const currentYear = moment().year();
	const TWO_YEARS_AFTER = currentYear + 2;
	return value >= START_YEAR && value <= TWO_YEARS_AFTER;
};

const getFixedYearsRange = () => {
	const currentYear = moment().year() + 2;
	const START_YEAR = 1900;
	return Array.from({ length: currentYear - START_YEAR + 1 }, (_, i) => ({
		label: (currentYear - i).toString(),
	}));
};

const getRelativeYearsRange = () => {
	const start = -10;
	const end = 2;
	return Array.from({ length: end - start + 1 }, (_, i) => {
		const year = start + i;
		let label;
		if (year === 0) {
			label = "0 Year";
		} else if (year === 1) {
			label = "1 Year";
		} else if (year === -1) {
			label = "-1 Year";
		} else {
			label = `${year} Years`;
		}
		return { label };
	}).reverse();
};

export { getRealNumberFromSelection, isYear, getFixedYearsRange, getRelativeYearsRange };
